const window = require('window');
const Backbone = require('backbone');
var RatingView = Backbone.View.extend({
	el: '.js-rating',
	events: {
		'click .js-rating': 'scrollToReviews'
	},
	scrollToReviews: function(e) {
		const reviewsId = window.BCOM.theme.isLivingDirect ? 'reviewsRow' : 'reviews';
		e.preventDefault();
		Backbone.trigger('tabContent:scrollTo', reviewsId);
	}
});

module.exports = RatingView;
